module.exports = __webpack_public_path__ + "static/img/Picture1.11ce074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191014/Picture1.jpg
// module id = Rq2W
// module chunks = 1